
class HXFormFieldDropdown extends HXFormField {

    constructor(inputName,formName) {
        super(inputName,formName);
    }

    /**
     * @returns {boolean}
     */
    validateInput(alertResult=true) {
        super._validateFieldInit();
        if (this.fieldExists()===true && this.getEditable() === true) {
            if (!this.getOptional() && this.getValue()=='0') {
                this.validationMsg = hx.replace(this.formVars.dictOptionalMsg, "#name#", this.getLabel());
                this.validationPassed = false;
            }
            if (alertResult===true) super._validateFieldAlert();
        }
        return this.validationPassed;
    }

    /**
     * Liefert den Text der gewaehlten Option
     * @returns {string}
     */
    getSelectedText() {
        return this.inputObj.options[this.inputObj.selectedIndex].text;
    }

    /**
     * Liefert den Value der gewaehlten Option - identisch zu .getValue()
     * @returns {string}
     */
    getSelectedValue() {
        return this.getValue();
    }

    /**
     * Liefert zurueck ob der Leereintrag "-" angezeigt wird
     * @returns {string}
     */
    getOptionEmptyDisplay() {
        return this.inputObj.getAttribute("data-hx-optionempty") === 'true';
    }

    /**
     * Liefert Text des Leereintrages, wenn dieser angezeigt wird
     * @returns {string}
     */
    getOptionEmptyText() {
        var text = $(".js-hx_dropdown_overlay-" + this.inputName).find(".js-hx_dropdown_overlay_list_item[data-value=0]").html();
        return text;
    }

    /**
     * Leereintrag "-" ein oder ausblenden
     * @param {Boolean} show
     * @param {String} text
     */
    setOptionEmpty(show,text="-") {
        var actualValue = this.getSelectedValue();
        // ein bzw. ausblenden der 0-Option:
        if (show==true){
            $(".js-hx_dropdown_overlay-" + this.inputName).find(".js-hx_dropdown_overlay_list_item[data-value=0]").attr("data-hidden", "0");
        }else{
            $(".js-hx_dropdown_overlay-" + this.inputName).find(".js-hx_dropdown_overlay_list_item[data-value=0]").attr("data-hidden", "1");
        }
        $(".js-hx_dropdown_overlay-" + this.inputName).find(".js-hx_dropdown_overlay_list_item[data-value=0]").html(text);
        this.inputObj.setAttribute("data-hx-optionempty",show);
        this.toggleEntryVisibilityByHidden();
        this.setValue(this.getValue()); // Dropdown aktualisieren
    }

    /**
     * das muss hier anders geloest werden, als in der HXFormField-Klasse, damit das Feld seine css-classes behaelt, auch bei focus und blur!
     * @param optional
     */
    setOptional(optional) {
        super.setOptional(optional,'dropdown');
    }


    /**
     * diese Funktion setzt den "add"-Eintrag in die Liste, wenn auf "add" geklickt wird.
     * wird diese Funktion erneut aufgerufen, so wird der "Add"-Eintrag ueberschrieben
     * @param {string} newText
     */
    setManualEntry(newText) {
        if(typeof newText == "undefined") newText = "";
        newText=newText.trim();
        if(newText != ""){

            $(this.inputObj).find("option").val('-1');
            $(this.inputObj).find("option").html(newText);
            $(this.inputObj).trigger("change");
            $(".js-hx_dropdown_input-" + this.inputName).val(newText);

            var obj = $(".js-hx_dropdown_overlay_list-" + this.inputName).find(".hx_dropdown_overlay_list_item[data-value='-1']");
            obj.html(newText);
            obj.attr("data-hidden", "0");
            this.setValue(-1);
            $(".js-hx_dropdown_overlay-" + this.inputName).find("input").val(''); // Suche leeren
            this.toggleEntryVisibilityByHidden();
        }
    }
    /**
     * diese Funktion setzt den "add"-Eintrag in die Liste, wenn auf "add" geklickt wird.
     * wird diese Funktion erneut aufgerufen, so wird der "Add"-Eintrag ueberschrieben!
     * @param {string} newText
     * @param {boolean} selectItNow  - dummy ohne Funktion, fuer Abwaertskompatibilitaet
     * @deprecated
     */
    addItem (newText,selectItNow=true){
        setManualEntry(newText);
    }

    /**
     * gibt den Value des Eintrags zurueck, welcher den uebergebenen Text enthaelt. Wenn nicht gefunden: null
     * @param text
     * @returns {string|null}
     */
    getEntryValueByText(text){
        var value = null;
        $(".js-hx_dropdown_overlay_list-" + this.inputName).find(".hx_dropdown_overlay_list_item[data-hidden!=0]").each((index, element)=>{
            if($(element).html() == text){
                value = $(element).attr("data-value");
            }
        });
        return value;
    }

    /**
     * Suchfunktion
     * fuehrt die Suche aus und setzt die Sichtbarkeit der Eintraege mit den data-hidden-Attributen
     */
    executeSearch(){
        var suchText = $(".js-hx_dropdown_overlay-" + this.inputName).find("input").val();
        var text ='';
        // alle Entries durchgehen und Sichtbarkeit setzen:
        $('.js-hx_dropdown_overlay-' + this.inputName).find('.js-hx_dropdown_overlay_list_item[data-value!="-1"][data-value!="0"]').each((index, element)=>{
            text = $(element).html();
            if (text.toLowerCase().indexOf(suchText.toLowerCase())>=0){
                // gefunden:
                element.setAttribute('data-hidden','0');
            }else{
                // nicht gefunden
                element.setAttribute('data-hidden','1');
            }
        });
        this.toggleEntryVisibilityByHidden();
    }


    /**
     * Setzt die Sichtbarkeit der Eintraege anhand der data-hidden-Attribute
     */
    toggleEntryVisibilityByHidden (){
        // Alle LIs durchgehen und sichtbar / unsichtbar machen:
        $(".js-hx_dropdown_overlay-" + this.inputName).find(".js-hx_dropdown_overlay_list_item").each((index, element)=>{

            if (element.getAttribute('data-hidden')=='0'){
                // eintrag sichtbar machen
                $(element).removeClass('hx_dropdown_overlay_list_item_hidden');

                if (element.getAttribute('data-selected')=='1'){
                    $(element).addClass("hx_dropdown_overlay_list_item-selected");
                }else{
                    $(element).removeClass("hx_dropdown_overlay_list_item-selected");
                }
            }else{
                // eintrag ausblenden
                $(element).addClass('hx_dropdown_overlay_list_item_hidden');
            }
        });
    }

    /**
     * Auswahl eines Entries.
     * Nur interne Verwendung!
     * wird von select und getValue() aufgerufen
     * @param $thisElement
     */
    selectEntry ($thisElement){
        $(".js-hx_dropdown_overlay_list-" + this.inputName).find(".hx_dropdown_overlay_list_item-selected").removeClass("hx_dropdown_overlay_list_item-selected");
        $thisElement.addClass("hx_dropdown_overlay_list_item-selected");
        $(this.inputObj).find("option").val($thisElement.data("value")).html($thisElement.html());
        $(".js-hx_dropdown_overlay-" + this.inputName).hide().data("active", 0);

        // alle data-selected=0
        $(".js-hx_dropdown_overlay_list-" + this.inputName).find(".hx_dropdown_overlay_list_item").attr("data-selected", "0");
        // aktuellen data-selected=1
        $thisElement.attr("data-selected", "1");
        $(this.inputObj).trigger("change");

        if($thisElement.find(".js-hx_dropdown_list_color_box").length != 0){
            $(this.inputObj).parent().find(".js-hx_dropdown_select_color_box-" + this.inputName).show();
            $(this.inputObj).parent().find(".js-hx_dropdown_select_color_box-" + this.inputName).css("background-color", $thisElement.find(".js-hx_dropdown_list_color_box").css("background-color"));
            $(this.inputObj).find("option").removeClass("hx_dropdown_select_item-null");
            $(this.inputObj).removeClass("hx_dropdown_select-color-null");
            $(this.inputObj).removeClass("hx_dropdown_select-icon-null");
        } else if($thisElement.find(".js-hx_dropdown_list_icon_box").length != 0){
            $(this.inputObj).parent().find(".js-hx_dropdown_select_icon_box-" + this.inputName).show();
            $(this.inputObj).parent().find(".js-hx_dropdown_select_icon_box-" + this.inputName).html($thisElement.find(".js-hx_dropdown_list_icon_box").html());
            $(this.inputObj).find("option").removeClass("hx_dropdown_select_item-null");
            $(this.inputObj).removeClass("hx_dropdown_select-icon-null");
            $(this.inputObj).removeClass("hx_dropdown_select-color-null");
        } else{
            $(this.inputObj).parent().find(".js-hx_dropdown_select_color_box-" + this.inputName).hide();
            $(this.inputObj).parent().find(".js-hx_dropdown_select_icon_box-" + this.inputName).hide();
            $(this.inputObj).find("option").addClass("hx_dropdown_select_item-null");
            $(this.inputObj).addClass("hx_dropdown_select-color-null");
        }
        $(this.inputObj).trigger("focus");
        this.closeOverlay ();
    }


    /**
     * Ausblenden des Dropdown
     */
    closeOverlay (){
        $(".js-hx_dropdown_overlay").hide().attr("data-active", 0);
        $(".js-hx_dropdown_select").removeClass("formselectnotnullfocus");
        $(".js-hx_dropdown_select").removeClass("formselectfocus");
        this.inputObj.focus();
    }

    /**
     * Einblenden des Dropdown
     * Scroll zum gewaehlten Eintrag
     */
    displayOverlay (){
        var closeMe = false;
        if($(".js-hx_dropdown_overlay-" + this.inputName).attr("data-active") == "1"){
            closeMe = true;
        }
        $(".js-hx_dropdown_overlay").hide().attr("data-active", 0);
        $(".js-hx_dropdown_select").removeClass("formselectnotnullfocus").removeClass("formselectfocus");
        if(!closeMe){
            if($(this.inputObj).hasClass("formselectnotnull")){
                $(this.inputObj).addClass("formselectnotnullfocus");
            }else{
                $(this.inputObj).addClass("formselectfocus");
            }
            $(".js-hx_dropdown_overlay-" + this.inputName).show().attr("data-active", 1);
            if($(".js-hx_dropdown_overlay-" + this.inputName).find("input").length > 0){
                $(".js-hx_dropdown_overlay-" + this.inputName).find("input").trigger("focus");
            }
            if($(".js-hx_dropdown_overlay_list-" + this.inputName + " .hx_dropdown_overlay_list_item-selected").length > 0){
                $(".js-hx_dropdown_overlay_list-" + this.inputName).scrollTop($(".js-hx_dropdown_overlay_list-" + this.inputName + " .hx_dropdown_overlay_list_item-selected").position().top);
            }

            var listMaxHeight = hx.cint($(this.inputObj).parent().find(".js-hx_dropdown_overlay_list").data("max_height"));
            var elementBottomDistance =  $(window).height()-($(this.inputObj).offset().top - $(document).scrollTop()) ;
            if (elementBottomDistance<listMaxHeight){
                $(".js-hx_dropdown_overlay-" + this.inputName).addClass("hx_dropdown_overlay-above");
                $(".js-hx_dropdown_overlay_list-" + this.inputName).css("bottom", $(".js-hx_dropdown_overlay-" + this.inputName).find(".js-hx_dropdown_overlay_search").height() + "px");
            }else{
                $(".js-hx_dropdown_overlay-" + this.inputName).removeClass("hx_dropdown_overlay-above");
            }

            // Scroll selection into view
            var element=$(".js-hx_dropdown_overlay_list-" + this.inputName).find('[data-selected="1"]');
            var container = $(".js-hx_dropdown_overlay_list-" + this.inputName);
            container.scrollTop(0);
            if (element[0]!=undefined){
                if (element.position().top > container.height()){
                    var position = element.position().top + container.scrollTop() - 30;
                    container.scrollTop(position);
                }
            }
        }
        if ($(".js-hx_dropdown_overlay_list-" + this.inputName).find('[data-selected="1"]').length>0){
            $(".js-hx_dropdown_overlay_list-" + this.inputName).find('[data-selected="1"]')[0].focus();
        }
    }

    /**
     * Macht 'val' im Dropdown wieder sichtbar
     * @param {string} val (key)
     */
    showEntry (val){
        if(val == "") return;
        $(".js-hx_dropdown_overlay-" + this.inputName).find(".js-hx_dropdown_overlay_list_item[data-value='" + val + "']").attr('data-hidden','0');
        this.toggleEntryVisibilityByHidden();
    }

    /**
     * Alle Eintraege werden wieder sichtbar
     */
    showAllEntries (){
        $(".js-hx_dropdown_overlay-" + this.inputName).find(".js-hx_dropdown_overlay_list_item[data-value!=0][data-value!=-1]").attr('data-hidden','0');
        this.toggleEntryVisibilityByHidden();
    }

    /**
     * Blendet 'val' aus der Liste aus (setzt data-hidden und refreshed die Liste) wird auch von Suche verwendet
     * @param {string} val (key)
     */
    hideEntry (val){
        if(val == "") return;
        $(".js-hx_dropdown_overlay-" + this.inputName).find(".js-hx_dropdown_overlay_list_item[data-value='" + val + "']").attr('data-hidden','1');
        this.toggleEntryVisibilityByHidden();
    }

    /**
     * Blendet alle Eintraege aus
     * ist nicht geeignet, um die Liste zu filtern, da die Suche das ein/ausblenden verwendet
     */
    hideAllEntries (){
        $(".js-hx_dropdown_overlay-" + this.inputName).find(".js-hx_dropdown_overlay_list_item[data-value!=0][data-value!=-1]").attr('data-hidden','1');
        this.toggleEntryVisibilityByHidden();
    }


    /**
     * Selektiert anhand von value
     * @param {string} val (key)
     * @deprecated
     * @see setValue()
     */
    select (val){
        this.setValue(val);
    }

    /**
     * setzt das Dropdown auf den gegebenen Wert (=value)
     * selbe Funktionalitaetr wie select()
     * @param {string|int} value
     */
    setValue(val){
        if(val === "") return;
        var obj = $(".js-hx_dropdown_overlay_list-" + this.inputName).find(".js-hx_dropdown_overlay_list_item[data-value=" + val + "]");
        if (obj.length>0){
            this.selectEntry(obj);
        }
    }


    /**
     * Setzt Liste auf den ersten Eintrag der nicht ausgeblendet ist (default 0)
     * @deprecated
     */
    reset (){
        var obj= $(".js-hx_dropdown_overlay_list-" + this.inputName).find(".js-hx_dropdown_overlay_list_item[data-hidden='0']:first");
        this.selectEntry(obj);
    }

    /**
     * Haengt Events ein
     */
    displayInit(){
        if(this.fieldExists()===true && this.getEditable()){
            // Ausblenden des Overlays // Event wird zentral im Document eingehaengt.
            $(document).on("click", (event) => {
                event.stopPropagation();
                var target = $(event.target);
                var targetParent = $(target.parent());
                if(!targetParent.hasClass("js-hx_dropdown_overlay_search") && !target.hasClass("js-hx_dropdown_select")){
                    $(".js-hx_dropdown_overlay-" + this.inputName).hide().attr("data-active", 0);
                    $(this.inputObj).parent().find(".js-hx_dropdown_select").removeClass("formselectnotnullfocus");
                    $(this.inputObj).parent().find(".js-hx_dropdown_select").removeClass("formselectfocus");
                }
            });

            // Overlay einblenden, wenn auf das Select geklickt wird
            $(this.inputObj).on("mousedown", (event) => {
                $(this.inputObj).trigger("blur");
                this.displayOverlay();
                return false;
            });

            // Tastatur Events abfangen fuer Select-Feld
            $(this.inputObj).on("keydown", (event) => {
                if((event.key=="ArrowDown" || event.key == "Enter" || event.key == " ")  && !event.ctrlKey){
                    $(this.inputObj).trigger("blur");
                    this.displayOverlay();
                    return false;
                }
                if ((event.key=="ArrowUp" || event.key=="ArrowDown") && !event.ctrlKey){
                    $(this.inputObj).trigger("blur");
                    this.displayOverlay();
                    return false;
                }
            });

            $(this.inputObj).parent().on("focusin", (event) => {
                if ($(this.inputObj).attr("data-has_focus") != "1") {
                    if($(this.inputObj).parent()[0].contains(document.activeElement)){
                        $(this.inputObj).attr("data-has_focus", "1");
                        this.inputObj.dispatchEvent(new Event('focus'));
                    }
                }
            });
            $(this.inputObj).parent().on("focusout", (event) => {
                if ($(this.inputObj).attr("data-has_focus") == "1") {
                    if($(this.inputObj).parent()[0].contains(document.activeElement)==false){
                        $(this.inputObj).attr("data-has_focus", "0");
                        this.inputObj.dispatchEvent(new Event('blur'));
                    }
                }
            });

            // Suchfeld: bei Tastendruck Suche ausfuehren
            $(".js-hx_dropdown_overlay-" + this.inputName).find("input").on("keyup", (event) => {
                this.executeSearch();
                return true;
            });

            // Such-Icon: bei Klick: Suche ausfuehren
            $(".js-hx_dropdown_overlay-" + this.inputName).find(".js-hx_dropdown_overlay_icon_search").on("click", (event) => {
                event.stopPropagation();
                this.executeSearch();
                $(".js-hx_dropdown_overlay_search_input-" + this.inputName).trigger("focus");
                var tmpVal = $(".js-hx_dropdown_overlay_search_input-" + this.inputName).val();
                $(".js-hx_dropdown_overlay_search_input-" + this.inputName).val("");
                $(".js-hx_dropdown_overlay_search_input-" + this.inputName).val(tmpVal);
            });

            // Tastatur Events abfangen fuer Suchfeld
            $(".js-hx_dropdown_overlay-" + this.inputName).find("input").on("keydown", (event) => {

                if ($(".js-hx_dropdown_overlay-" + this.inputName).hasClass("hx_dropdown_overlay-above")){
                    // Darstellung oberhalb. Daher Pfeilrichtungen umdrehen
                    if (event.key == "ArrowUp" && !event.ctrlKey){
                        $('.js-hx_dropdown_overlay_list-' + this.inputName + ' .hx_dropdown_overlay_list_item[data-hidden="0"]:first').trigger("focus");
                        return false;
                    }
                }else{
                    if (event.key == "ArrowDown" && !event.ctrlKey){
                        $('.js-hx_dropdown_overlay_list-' + this.inputName + ' .hx_dropdown_overlay_list_item[data-hidden="0"]:first').trigger("focus");
                        return false;
                    }
                }


                if(event.key == "Escape"){
                    $(".js-hx_dropdown_overlay-" + this.inputName).hide();
                    $(this.inputObj).removeClass("formselectnotnullfocus");
                    $(this.inputObj).removeClass("formselectfocus");
                    return false;
                }
                return true;
            });

            // Hinzufuegen von Eingegebenen Suchbegriff in Liste und Auswahl im Select
            $(".js-hx_dropdown_overlay-" + this.inputName).find(".js-hx_dropdown_overlay_icon_add").on("click", (event) => {
                event.stopPropagation();
                var newText = $(".js-hx_dropdown_overlay-" + this.inputName).find("input").val();
                // Bestehenden Inhalt suchen. Nur wenn nicht gefunden: ergaenzen
                if (this.getEntryValueByText(newText)==null){
                    this.setManualEntry(newText);
                }
            });
        }

        // Jetzt noch jeder Eintrag in der LI-Liste:
        var $hxDropdownOverlayListItems = $(".js-hx_dropdown_overlay_list-" + this.inputName).find(".js-hx_dropdown_overlay_list_item");
        // Auswaehlen einer Option
        $hxDropdownOverlayListItems.on("click", (event) =>{
            event.stopPropagation();
            this.selectEntry($(event.target));
        });
        // Tastatur Befehle abfangen List Item
        $hxDropdownOverlayListItems.on("keydown", (event) => {
            if(event.key == "ArrowUp" && !event.ctrlKey){ // Arrow Up

                if($(event.target).prevAll('.js-hx_dropdown_overlay_list_item[data-hidden="0"]:first').length > 0){
                    $(event.target).prevAll('.js-hx_dropdown_overlay_list_item[data-hidden="0"]:first').trigger("focus");
                }else{
                    $(".js-hx_dropdown_overlay-" + this.inputName).find("input").trigger("focus");
                }
                return false;
            }else if(event.key == "ArrowDown" && !event.ctrlKey){
                $(event.target).nextAll('.js-hx_dropdown_overlay_list_item[data-hidden="0"]:first').trigger("focus");
                return false;
            }else if(event.key == "Enter"){
                this.selectEntry($(event.target));
                return false;
            }else if(event.key == "Escape"){
                this.closeOverlay();
                return false;
            }else if(event.key == " "){
                return false;  // Space soll nichts bewirken!
            }else if (event.key == "Tab"){
                this.closeOverlay();
                $(this).trigger("focus");
                return false;
            }
        });
        this.toggleEntryVisibilityByHidden();
    }

}
